import React from 'react'
import AuthCard from './AuthCard'

export default function ExistingUserCard({ children }) {
  return (
    <AuthCard>
      {children}
    </AuthCard>
  )
}
